import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Card, CardBody, Col, Container, FormGroup, Input, Label, Row, Table } from 'reactstrap';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import Loader from '../../../components/Loader';
import { getCurrentUserData } from 'utils/helper';
import AuthService from 'common/auth.service';

const CDNCacheList = () => {
  toast.configure();

  const [cdnURL, setCDNURL] = useState('');
  const [fetchURLData, setFetchURLData] = useState(false);
  const [headersData, setHeadersData] = useState({});
  const [clearCacheResponse, setClearCacheResponse] = useState({});

  const auth = new AuthService();
  const token = auth.getSessionCookie();

  const { apiKey, apiURL } = getCurrentUserData('schoolmykids');

  const commonHeaders = {
    'Content-Type': 'application/json',
    'x-api-key': apiKey,
    Authorization: `Bearer ${token}`,
  };

  const sourceOptions = [
    { value: 'schoolmykids', label: 'SchoolMyKids' },
    { value: 'theparentz', label: 'TheParentz' },
    { value: 'periodtracker', label: 'PeriodTracker' },
  ];

  const defaultFilters = {
    source1: sourceOptions[0]?.value,
    source2: sourceOptions[0]?.value,
    url: '',
  };
  const [filters, setFilters] = useState(defaultFilters);

  const [clearCacheLoading, setClearCacheLoading] = useState(false);
  const [urlHeadersLoading, setURLsHeadersLoading] = useState(false);

  const getURLsHeaders = async (payload) => {
    setURLsHeadersLoading(true);
    try {
      const response = await fetch(`${apiURL}/admin-tools/checkHeaders`, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: commonHeaders,
      });

      const data = await response.json();
      if (!response.ok || !isEmpty(data?.message)) {
        throw new Error(data?.message || 'Failed to clear cache');
      }

      toast.success('Success! URL Headers fetched');
      setHeadersData(data);
    } catch (err) {
      toast.error(err?.message || 'An error occurred');
    } finally {
      setURLsHeadersLoading(false);
    }
  };

  const clearCacheRequest = async (payload) => {
    setClearCacheLoading(true);
    try {
      const response = await fetch(`${apiURL}/admin-tools/clearCDNCache`, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: commonHeaders,
      });

      const data = await response.json();
      if (!response.ok || !isEmpty(data?.message)) {
        throw new Error(data?.message || 'Failed to clear cache');
      }

      setFilters(defaultFilters);
      toast.success('Success! Cache cleared');
      setClearCacheResponse(data);
    } catch (err) {
      toast.error(err?.message || 'An error occurred');
    } finally {
      setClearCacheLoading(false);
    }
  };

  const fetchData = () => {
    if (isEmpty(cdnURL) && isEmpty(filters.url)) {
      toast.error('Enter CDN URL or URL....');
    } else {
      if (cdnURL == '') {
        if (!isEmpty(filters.url)) {
          const urlArray = filters.url?.split('\n');
          const filteredURL = urlArray?.map((e) => e?.trim())?.filter((elem) => elem);
          const removeSourceInUrl = filteredURL
            ?.map((e) => e?.replaceAll('https://www.schoolmykids.com', ''))
            ?.map((e) => e?.replaceAll('https://www.theparentz.com', ''));

          clearCacheRequest({
            urls: removeSourceInUrl,
            source: filters.source1,
          });
        } else {
          toast.error('Please enter URL....');
        }
      } else {
        setFetchURLData(true);
        getURLsHeaders({
          urls: [cdnURL],
          source: filters.source2,
        });
      }
    }
  };

  return (
    <>
      <div className="page-content">
        <Loader isActive={clearCacheLoading || urlHeadersLoading} />

        <Container fluid>
          <Breadcrumbs title="Others" breadcrumbItem="Clear CDN Cache" />

          <Card>
            <CardBody>
              <div>
                <Row>
                  <Col md={12}>
                    <FormGroup className="mb-4">
                      <div className="col-lg-3">
                        <Label className="form-label">Source</Label>
                        <Select
                          options={sourceOptions}
                          value={sourceOptions?.find((e) => e?.value === filters?.source1)}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              source1: e?.value,
                            })
                          }
                        />
                      </div>
                    </FormGroup>

                    <FormGroup>
                      <Label className="form-label">URL</Label>
                      <Input
                        type="textarea"
                        placeholder="Enter URL"
                        rows={'10'}
                        value={filters.url}
                        onChange={(e) => {
                          setFilters({
                            ...filters,
                            url: e.target.value,
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div className="mt-4">
                <a className="btn btn-primary me-4 px-4" onClick={fetchData}>
                  Clear CDN Cache
                </a>
                <a
                  className="btn btn-light me-4 px-4"
                  onClick={() => {
                    setFilters(defaultFilters);
                  }}>
                  Clear
                </a>
              </div>
            </CardBody>
          </Card>

          <Card>
            <h5 className="border-bottom  mb-2 py-3 px-4">Check Headers</h5>
            <CardBody>
              <div>
                <FormGroup className="mb-4">
                  <div className="col-lg-3">
                    <Label className="form-label">Source</Label>
                    <Select
                      options={sourceOptions}
                      value={sourceOptions?.find((e) => e?.value === filters?.source2)}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          source2: e?.value,
                        })
                      }
                    />
                  </div>
                </FormGroup>

                <FormGroup className="mb-4">
                  <Label className="form-label">URL</Label>
                  <Input
                    type="text"
                    value={cdnURL}
                    placeholder="Enter URL"
                    onChange={(e) => {
                      setCDNURL(e.target.value);
                      setFetchURLData(false);
                    }}
                  />
                </FormGroup>
              </div>

              <div className="mt-4 pt-2">
                <a className="btn btn-primary me-4 px-4" onClick={fetchData}>
                  Check Headers
                </a>
                <a
                  className="btn btn-light me-4 px-4"
                  onClick={() => {
                    setFetchURLData(false);
                    setCDNURL('');
                  }}>
                  Clear
                </a>
              </div>
            </CardBody>
          </Card>

          {!isEmpty(cdnURL) && fetchURLData && (
            <Row>
              <Col md={12}>
                <Card>
                  <CardBody>
                    {/* <div className="text-end w-100">
                      <a className="btn btn-light me-4 " onClick={clearCache}>
                        Clear Cache
                      </a>
                    </div> */}
                    <div className="table-responsive">
                      <Table className="project-list-table  table-centered table-striped">
                        <thead>
                          <tr className="table-warning">
                            <th>Keys</th>
                            <th>Values</th>
                          </tr>
                        </thead>

                        <tbody>
                          {!isEmpty(clearCacheResponse) &&
                            Object.keys(clearCacheResponse)?.map((key) => (
                              <tr>
                                <td>{key}</td>
                                <td>{clearCacheResponse[key]}</td>
                              </tr>
                            ))}
                          {isEmpty(clearCacheResponse) &&
                            Object.keys(headersData)?.map((key) => (
                              <tr>
                                <td>{key}</td>
                                <td>{headersData[key]}</td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </>
  );
};

export default CDNCacheList;
